import { TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { NumericFormat, OnValueChange } from 'react-number-format';

interface DataGridNumericFormatProps extends GridRenderEditCellParams {
	isCurrency?: boolean;
	isNumber?: boolean;
	decimalScale?: number;
}

const DataGridNumericInput = (props: DataGridNumericFormatProps) => {
	const { id, field, value, hasFocus, isCurrency, isNumber, decimalScale } = props;
	const [valueState, setValueState] = useState<number | undefined>(value as number);
	const inputRef = useRef<HTMLInputElement | null>(null);
    
	const apiRef = useGridApiContext();

	useLayoutEffect(() => {
		if (hasFocus && inputRef.current) {
			inputRef.current.focus();
		}
	}, [hasFocus, inputRef]);

	const handleChange: OnValueChange = useCallback(
		(values) => {
			const { floatValue } = values;
			setValueState(floatValue);
			apiRef.current.setEditCellValue({ id, field, value: floatValue, debounceMs: 200 });
		},
		[apiRef, field, id]
	);

	return (
		<NumericFormat
			value={valueState}
			customInput={TextField}
			{...(isCurrency || isNumber ? { thousandSeparator: true } : {})}
			decimalScale={decimalScale ?? 0}
			fixedDecimalScale
			allowNegative={false}
			{...(isCurrency ? { prefix: '$' } : {})}
			variant='standard'
			sx={{
				'& .MuiInputBase-root': {
					backgroundColor: 'transparent',
                    height: '100%',
				},
                backgroundColor: 'transparent',
			}}
			InputProps={{ disableUnderline: true }}
			onValueChange={handleChange}
            inputRef={inputRef}
			// getInputRef={setInputRef} // Type-safe way to set ref
		/>
	);
};

export default DataGridNumericInput;
